import http from './public'

export default {
    // 获取用户信息
    userInfo: (params) => {
        return http.fetchGet('userInfo', params)
    },
    // 登录验证token
    login: (params) => {
        return http.fetchGet('login', params)
    },
}